/**
 * Auto-generated by scripts/generate-drizzle-schema.mjs
 * Regenerate with: make generate-schema
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// Dataset pequeño por usuario — índices no necesarios por ahora.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Dataset pequeño — índices no necesarios por ahora.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Sesiones activas del usuario — dataset pequeño, sin índices.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
  expires_at: text("expires_at"),
  token: text("token"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  ip_address: text("ip_address"),
  user_agent: text("user_agent"),
  user_id: text("user_id"),
  active_organization_id: text("active_organization_id"),
  device_id: text("device_id"),
});

// Dataset global pequeño (~20 temas) — índices no necesarios.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// Solo 1 fila por usuario — índices no necesarios.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  banned: integer("banned"),
  ban_reason: text("ban_reason"),
  ban_expires: text("ban_expires"),
  two_factor_enabled: integer("two_factor_enabled"),
  two_factor_secret: text("two_factor_secret"),
  two_factor_backup_codes: text("two_factor_backup_codes"),
  deletion_requested_at: text("deletion_requested_at"),
});

// ═══════════════════════════════════════════════════════════════════════════
// VAULT (zero-knowledge) — mirrors server tables, syncs via PowerSync.
// Every sensitive field is an opaque encrypted blob; the client decrypts in
// memory only. See packages/shared/src/crypto.
// ═══════════════════════════════════════════════════════════════════════════

// 1 fila por usuario — la raíz de claves de la cuenta (blobs opacos + KDF).
// PowerSync exige que la PK local sea la columna `id`; el servidor keyea por
// user_id, así que en el cliente `id === user_id` (la fila se sincroniza con ese
// id). Mantenemos `user_id` como columna para consultas explícitas.
export const vault_account = sqliteTable("vault_account", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  kdf: text("kdf"),
  protected_account_key: text("protected_account_key"),
  protected_private_key: text("protected_private_key"),
  public_key: text("public_key"),
  auth_hash: text("auth_hash"),
  recovery_blob: text("recovery_blob"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

// Vaults personales u de organización. `protected_key` envuelve la clave del
// vault; `name_envelope` cifra el nombre visible.
export const vault = sqliteTable(
  "vault",
  {
    id: text("id").primaryKey(),
    type: text("type"),
    owner_user_id: text("owner_user_id"),
    organization_id: text("organization_id"),
    name_envelope: text("name_envelope"),
    protected_key: text("protected_key"),
    key_epoch: integer("key_epoch"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE owner_user_id = ? en la lista de vaults del usuario */
    index("vault_by_owner").on(table.owner_user_id),
  ],
);

// Un item = un SOBRE cifrado (login/note/card/identity) + su revisión.
export const vault_item = sqliteTable(
  "vault_item",
  {
    id: text("id").primaryKey(),
    vault_id: text("vault_id"),
    envelope: text("envelope"),
    rev: integer("rev"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE vault_id = ? AND deleted_at IS NULL en la lista de items */
    index("vault_item_by_vault").on(table.vault_id, table.updated_at),
  ],
);

// Adjunto cifrado de un item: 3 blobs OPACOS (contenido, clave de contenido
// envuelta, metadatos cifrados). El servidor solo custodia ciphertext.
export const vault_attachment = sqliteTable(
  "vault_attachment",
  {
    id: text("id").primaryKey(),
    vault_id: text("vault_id"),
    item_id: text("item_id"),
    wrapped_key: text("wrapped_key"),
    meta_envelope: text("meta_envelope"),
    blob: text("blob"),
    size: integer("size"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE item_id = ? AND deleted_at IS NULL en la lista de adjuntos de un item */
    index("vault_attachment_by_item").on(table.item_id),
  ],
);

// Pertenencia a un vault de organización: la clave del vault sellada al miembro.
export const vault_membership = sqliteTable(
  "vault_membership",
  {
    id: text("id").primaryKey(),
    vault_id: text("vault_id"),
    user_id: text("user_id"),
    role: text("role"),
    sealed_vault_key: text("sealed_vault_key"),
    key_epoch: integer("key_epoch"),
    created_at: text("created_at"),
  },
  (table) => [index("vault_membership_by_user").on(table.user_id)],
);

// Compartición puntual usuario→usuario (sobre ECIES sellado).
export const vault_share = sqliteTable("vault_share", {
  id: text("id").primaryKey(),
  from_user_id: text("from_user_id"),
  to_user_id: text("to_user_id"),
  sealed: text("sealed"),
  expires_at: text("expires_at"),
  created_at: text("created_at"),
});

export const drizzleSchema = {
  font_family,
  font_variant,
  member,
  organization,
  session,
  themes,
  user,
  vault_account,
  vault,
  vault_item,
  vault_attachment,
  vault_membership,
  vault_share,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

// Tablas de dominio del usuario con columna `user_id`, consumidas por el sweep
// invitado→cuenta (`sweepVisitorData`) y el snapshot P2P (`buildSnapshot`), que
// filtran/re-estampan por `user_id`. En la Bóveda (zero-knowledge) son las filas
// del usuario keyeadas por `user_id`: la raíz de cuenta y las membresías de
// vaults de organización. Los `vault`/`vault_item` se keyean por `owner_user_id`
// / `vault_id`, no por `user_id`, así que su transferencia/re-parentado la maneja
// la capa de vault, no este barrido genérico.
export const USER_DATA_TABLES = ["vault_account", "vault_membership"] as const;

export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
export type VaultAccount = InferSelectModel<typeof vault_account>;
export type VaultAccountInsert = InferInsertModel<typeof vault_account>;
export type VaultAccountRecord = VaultAccount;
export type Vault = InferSelectModel<typeof vault>;
export type VaultInsert = InferInsertModel<typeof vault>;
export type VaultRecord = Vault;
export type VaultItem = InferSelectModel<typeof vault_item>;
export type VaultItemInsert = InferInsertModel<typeof vault_item>;
export type VaultItemRecord = VaultItem;
export type VaultAttachment = InferSelectModel<typeof vault_attachment>;
export type VaultAttachmentInsert = InferInsertModel<typeof vault_attachment>;
export type VaultAttachmentRecord = VaultAttachment;
export type VaultMembership = InferSelectModel<typeof vault_membership>;
export type VaultMembershipInsert = InferInsertModel<typeof vault_membership>;
export type VaultMembershipRecord = VaultMembership;
export type VaultShare = InferSelectModel<typeof vault_share>;
export type VaultShareInsert = InferInsertModel<typeof vault_share>;
export type VaultShareRecord = VaultShare;
